<template>
  <v-container class="container-flex-anim" d-flex justify-center align-center fluid pa-0>
    <div class="anim">
      <svg xmlns="http://www.w3.org/2000/svg" width="300" height="320">
        <g fill="none" fill-rule="evenodd" transform="translate(-10,-150)">
            <path id="logo-path" fill="none" stroke="#1f97b9" d="M287.6,300.4c-1.1-6.6-3.8-13.3-8-20c-18.1-28.7-61.3-95-61.3-95c-7.8-12-18.5-19-31.7-20.7c-10.8-1.4-21.7-1.1-33.2-0.9
        c-3.6,0.1-7.3,0.2-11.1,0.2c5.6,13.9,17.3,21.6,32.7,21.4c11.9-0.2,20.9,4.3,26.7,13.5c6,9.3,52.5,82.7,59.7,93.6
        c6.5,9.9,6.7,20.1,0.6,29.7c0,0-41.2,65-59.9,94.1c-4.9,7.7-11.8,13.1-21,14.2c-1.7,0.2-14.1,1-15.9,0.6
        c-32.9,0.7-25.1-10.8-23.9-13.3c3-4.7,40.7-63.1,53.3-83.2c8.9-14.2,10.8-28.1,5.7-42.1c-1.5-4-3.5-8.1-6.1-12.2
        C192,277.2,159.9,227,147,207l-15.6-24.3c-3.4-4.6-6.8-8-10.4-10.3c-5.7-4.2-12.3-6.8-19.6-7.8c-8.5-1.1-17.1-1.2-26-1.1l0,0
        c0,0-36.2,0.3-35.9,0.8c-15.6,3.4-15.7,18.7-13.4,24c1.9,4.6,25.7,43.1,25.7,43.1l0.2-0.1C63.7,249.8,91.1,293,91.1,293
        c6.1,9.6,5.9,19.8-0.6,29.7c-7.1,10.9-14,21.5-20.7,32.1c-3.2,5.1-38.8,60.8-39.3,61.6c-7.2,10.6-6.2,14.9-6.3,17.7
        c0,5.7,2,9.4,4.6,11.9c4.4,4.3,10.5,4.8,10.5,4.8s38.7,1.1,50.1,0.9c3.6-0.1,7.3-0.2,11-0.2c-5.6-13.8-17.2-21.5-32.4-21.2
        c-3.2,0.1-6.2-0.3-8.9-0.9c0,0,0,0,0,0c-1.2-0.3-2.1-0.7-2.9-1.2c-3-1.6-3.9-5.5-2.1-8.3L69.2,396c1.7-3.4,37.2-57.9,39.3-61.1
        c2.6-4.1,4.7-8.1,6.1-12.2c5.1-14,3.2-27.9-5.7-42.1c-12.6-20.1-25.5-40.3-38.4-60.3c0,0-11.8-18.2-14.8-22.9
        c-1.2-2.5-4.6-13.1,28.3-12.4c2.6,0,9.5,0.4,11.2,0.6c5.8,0.7,10.7,2.7,14.9,5.9c2.6,2.5,5.5,6.1,8.7,10.9
        c0.1,0.2,57.7,90.6,57.7,90.6c6.1,9.6,5.7,19.1-0.6,29.7c-6.6,11.2-62.6,101.3-63.5,102.9c-3.3,5.9-3.5,21.5,12.1,25
        c-0.3,0.5,36.7,1.3,36.7,1.3l0,0c8.9,0.1,17.5,0,26-1.1c13.2-1.8,23.8-8.8,31.6-20.8c0,0,43-66.4,61-95.2
        C287,323.1,289.6,311.8,287.6,300.4z"/>
        </g>
      </svg>
    </div>
  </v-container>
</template>

<script>
import anime from 'animejs/lib/anime.es.js';

export default {
  name: 'LoadingLogo',
  data () {
    return {
      //
    }
  },
  mounted(){
    anime({
      targets: '#logo-path',
      strokeDashoffset: [anime.setDashoffset, 0],
      duration: anime.random(2000, 3000),
      delay: 0,
      loop: true,
      direction: 'alternate',
      easing: 'easeInOutSine',
      autoplay: true
    });
  }

}
</script>
<style type="text/css">
.container-flex-anim{margin:0;flex: 0 0 0;}
.anim{
  text-align:center;
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
}
.anim path {
  stroke-width: 3;
}
</style>